import { render, staticRenderFns } from "./taBtnCont.vue?vue&type=template&id=1e6b6567&scoped=true&"
import script from "./taBtnCont.vue?vue&type=script&lang=js&"
export * from "./taBtnCont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6b6567",
  null
  
)

export default component.exports